<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <modal :adaptive="true" height="auto" name="request">
            <d-container fluid>
                <d-form-row class="mt-3 mb-3">
                    <d-col class="mb-3">
                        <d-form-text tag="h6" class="m-0">In order to calculate a correct price for your situation, we need to know some details. Please estimate your monthly commission and your total monthly number of transactions</d-form-text>
                    </d-col>
                    <d-col md="12" class="form-group">
                        <label for="commission">Commission</label>
                        <d-input required type="text" id="commission" placeholder="monthly commission" />
                    </d-col>
                    <d-col md="12" class="form-group">
                        <label for="transactions">Number of transactions</label>
                        <d-input required type="text" id="transactions" placeholder="monthly number of transactions" />
                    </d-col>
                    <d-col md="12" class="d-flex justify-content-end">
                        <button v-on:click="showSuccess" type="submit" class="btn mt-3 btn-outline-primary btn-sm">SEND</button>
                        <button v-on:click="hide" class="mt-3 ml-3 btn btn-outline-warning btn-sm">CANCEL</button>
                    </d-col>
                </d-form-row>
            </d-container>
        </modal>
        <modal :adaptive="true" height="auto" name="success">
            <d-container fluid class="mb-3">
                <d-col class="mt-5 mb-3 d-flex justify-content-center">
                    <i class="material-icons check">check_circle</i>
                </d-col>
                <d-col class="mb-3">
                    <h3 class="text-center">Thank you!</h3>
                </d-col>
                <d-col class="mb-3">
                    <h6 class="text-center">We've received your request. Within 1 bussiness day we make you an offer you can't refuse! 😉</h6>
                </d-col>
                <d-col class="d-flex justify-content-center">
                    <button v-on:click="hideSuccess" class="mt-3 ml-3 btn btn-success btn-sm">OK</button>
                </d-col>
            </d-container>
        </modal>
        <modal :adaptive="true" height="auto" name="no-active-subscription">
            <d-container fluid class="mb-3">
                <d-col class="mt-5 mb-3 d-flex justify-content-center">
                    <i class="material-icons text-warning" style="font-size: 80px">warning</i>
                </d-col>
                <d-col class="mb-3">
                    <h3 class="text-center">No active subscription!</h3>
                </d-col>
                <d-col class="mb-3">
                    <h6 class="text-center">Your account is not activated. Please select a plan that suits your goals!</h6>
                </d-col>
                <d-col class="d-flex justify-content-center">
                    <button v-on:click="hideNoActiveSubscription" class="mt-3 ml-3 btn btn-success btn-lg">Pick a plan!</button>
                </d-col>
            </d-container>
        </modal>
        <billing-finetune/>
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Billing</h3>
            </d-col>
        </d-row>
        <d-row>
            <d-col lg="12" class="mb-4">
                <d-card class="card-small" v-if="checkPermission(permissionTypes.billingRead)">
                    <d-card-header>
                        <h5 class="m-0">Your Billing Plan</h5>
                        <template v-if="(userInfo.subscription) && (! userInfo.subscription.plan.isDefault && checkPermission(permissionTypes.billingWrite))">
                            <d-link
                                tag="button"
                                :to="{ name: 'update-payment-info' }"
                                class="btn mt-2 btn-primary"
                            >
                                Update payment info
                            </d-link>
                        </template>
                        <d-row v-if="checkPermission(permissionTypes.billingWrite)" class="d-flex justify-content-center">
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title"><u>1. Select monthly billing plan</u></h6>
                            </d-col>
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title">2. Billing address</h6>
                            </d-col>
                            <d-col cols="4" class="bar">
                                <h6 class="m-0 mt-5 text-center bar__title">3. Payment method</h6>
                            </d-col>
                        </d-row>
                        <d-progress v-if="checkPermission(permissionTypes.billingWrite)" :value="percent" :max="100" />
                    </d-card-header>
                    <billing-plans :modal="$modal"/>
                    <d-card-footer v-if="checkPermission(permissionTypes.billingWrite)" class="d-flex justify-content-end">
                        <d-button tag="button" class="btn btn-success btn-sm" @click="handleNextStep">Next</d-button>
                    </d-card-footer>
                </d-card>
                <no-permission-message v-else />
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import BillingPlans from '@/components/billing/BillingPlans.vue';
import BillingFinetune from '@/components/billing/BillingFinetune.vue';
import notification from '@/mixins/notification';
import permissions from '../../mixins/permissions';

export default {
    mixins: [notification, permissions],

    data() {
        return {
            percent: 25,
        };
    },

    computed: {
        userInfo() {
            return this.$store.getters.userInfo
        },
    },

    components: {
        BillingPlans,
        BillingFinetune
    },

    methods: {
        hide() {
            this.$modal.hide('request');
        },

        handleNextStep() {
            if (this.$store.getters.getBillingInfo.planId) {
                this.$router.push('/billing-address')
            } else {
                this.showNotification('warn', 'We have a problem', 'Choose a plan to continue')
            }
        },

        showSuccess() {
            this.$modal.hide('request');
            this.$modal.show('success');
        },

        hideSuccess() {
            this.$modal.hide('success');
        },

        hideNoActiveSubscription() {
            this.$modal.hide('no-active-subscription');
        },
    },

    mounted() {
        if (this.$store.getters.currentUser.info.subscription.plan.name === 'Require pay plan') {
            this.$modal.show('no-active-subscription');
        }
    }
};
</script>
